<template>
    <v-select
        v-model="selectedProduct"
        label="name"
        placeholder="Search..."
        :options="products"
        :disabled="disabled"
        @search="onSearch"
    >
        <template slot="no-options">
            Start typing to search for a product
        </template>
    </v-select>
</template>

<script>
import { mapActions } from 'vuex';

export default {
    props: {
        value: {
            type: Object,
            required: false,
            default: null
        },

        shopId: {
            type: String,
            required: true
        },

        disabled: {
            type: Boolean,
            required: false,
            default: false
        }
    },

    data() {
        return {
            selectedProduct: null,
            products: []
        };
    },

    watch: {
        selectedProduct() {
            this.$emit('input', this.selectedProduct || null);
        }
    },

    async created() {
        const id = this.value?.id;

        if (!id) {
            return;
        }

        try {
            this.selectedProduct = await this.getProduct(id);

            this.products.push(this.selectedProduct);
        } catch (error) {
            console.error(error);
        }
    },

    methods: {
        ...mapActions({
            getProducts: 'shops/getProducts',
            getProduct: 'products/show'
        }),

        async onSearch(search, loading) {
            if (!search) {
                this.products = this.selectedProduct
                    ? [this.selectedProduct]
                    : [];

                return;
            }

            loading(true);

            try {
                const { rows: products } = await this.getProducts({
                    id: this.shopId,
                    search
                });

                if (
                    this.selectedProduct &&
                    products.every(
                        product => product.id !== this.selectedProduct.id
                    )
                ) {
                    products.push(this.selectedProduct);
                }

                this.products = products;
            } catch (error) {
                console.error(error);

                this.$toasterError();
            }

            loading(false);
        }
    }
};
</script>
